import CmlStorageEstimationIndex from "@/components/billing_cml/storage_estimation/StorageEstimationIndex.vue";

let routesStorageEstimationAccess= [
    {
        path: '',
        meta: {
          title: "CML Storage Estimation",
        },
        name: "CmlStorageEstimationIndex",
        component: CmlStorageEstimationIndex
    }
    
]

export default routesStorageEstimationAccess
  